<template>
  <div class="workDetails" v-if="workDialogVisible">
    <el-dialog
      width="92%"
      custom-class="work-process-dialog"
      :visible.sync="workDialogVisible"
      append-to-body
      @close="$emit('update:visible', false)"
    >
      <div slot="title" class="work-dialog__title">
        <div class="work-dialog__title-main">
          <span class="work-dialog__sn">工单处理</span>
          <el-tag
            v-if="workList.orderSn"
            size="small"
            type="info"
            effect="plain"
          >{{ workList.orderSn }}</el-tag>
          <el-tag
            size="small"
            effect="plain"
            :type="workList.status === 2 ? 'success' : workList.status === 3 ? 'danger' : 'warning'"
          >{{ workList.status | formatStatus }}</el-tag>
          <el-tag
            v-if="workList.workType"
            size="small"
            type="info"
            effect="plain"
          >{{ workOrderStatus(workList.workType) }}</el-tag>
        </div>
      </div>

      <div class="work-detail-body">
        <!-- 状态摘要 -->
        <div
          class="work-status-bar"
          :class="{
            'work-status-bar--success': workList.status === 2,
            'work-status-bar--danger': workList.status === 3,
          }"
        >
          <i
            :class="
              workList.status === 2
                ? 'el-icon-circle-check'
                : 'el-icon-warning-outline'
            "
          ></i>
          <span>当前工单状态：{{ workList.status | formatStatus }}</span>
        </div>

        <!-- 订单摘要 -->
        <div class="work-summary" v-if="orderData.orderSn">
          <div class="work-summary__item">
            <span class="work-summary__label">实付 / 平均金额</span>
            <span class="work-summary__value work-summary__value--primary">
              ¥{{ orderData.payAmount != null ? orderData.payAmount : "0.00" }}
            </span>
          </div>
          <div class="work-summary__item" v-if="workList.orderType == 0">
            <span class="work-summary__label">下单衣物</span>
            <span class="work-summary__value">{{ orderData.itemQuantity || 0 }} 件</span>
          </div>
          <div class="work-summary__item" v-if="workList.orderType == 0">
            <span class="work-summary__label">实际衣物</span>
            <span class="work-summary__value">{{ orderData.itemRealityQuantity || 0 }} 件</span>
          </div>
          <div class="work-summary__item">
            <span class="work-summary__label">微信 / 余额</span>
            <span class="work-summary__value">
              {{ orderData.wxAmount || 0 }} / {{ orderData.balancelAmount || 0 }}
            </span>
          </div>
          <div class="work-summary__item">
            <span class="work-summary__label">客户</span>
            <span class="work-summary__value">{{ orderData.senderName || "-" }}</span>
          </div>
          <div class="work-summary__item">
            <span class="work-summary__label">手机号</span>
            <span class="work-summary__value">{{ orderData.senderPhone || "-" }}</span>
          </div>
        </div>

        <div class="detail-cards">
          <!-- 订单信息 -->
          <section class="detail-section" v-if="orderData.orderSn">
            <div class="detail-section__head">
              <i class="el-icon-document detail-section__icon"></i>
              <h3 class="detail-section__title">订单信息</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="3" size="small" border>
                <el-descriptions-item v-if="orderData.factoryName" label="工厂">
                  {{ orderData.factoryName }}
                </el-descriptions-item>
                <el-descriptions-item label="订单编号">
                  <el-link
                    @click="getOrderClick(orderData)"
                    :underline="false"
                    type="primary"
                  >{{ orderData.orderSn }}</el-link>
                </el-descriptions-item>
                <el-descriptions-item label="订单来源">
                  {{ orderData.channelName || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="客户">
                  {{ orderData.senderName || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="手机号">
                  {{ orderData.senderPhone || "-" }}
                </el-descriptions-item>
                <el-descriptions-item
                  v-if="workList.orderType == 0"
                  label="下单衣物"
                >{{ orderData.itemQuantity }}</el-descriptions-item>
                <el-descriptions-item
                  v-if="workList.orderType == 0"
                  label="实际衣物"
                >{{ orderData.itemRealityQuantity }}</el-descriptions-item>
                <el-descriptions-item
                  v-if="workList.orderType != 1"
                  label="实付金额"
                >{{ orderData.payAmount }}</el-descriptions-item>
                <el-descriptions-item
                  v-if="workList.orderType == 1"
                  label="平均金额"
                >{{ orderData.payAmount }}</el-descriptions-item>
                <el-descriptions-item label="微信支付">
                  {{ orderData.wxAmount != null ? orderData.wxAmount : 0 }}
                </el-descriptions-item>
                <el-descriptions-item label="余额支付">
                  {{ orderData.balancelAmount != null ? orderData.balancelAmount : 0 }}
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <!-- 衣物明细 -->
          <section class="detail-section detail-section--full" v-if="clothingData.length != 0">
            <div class="detail-section__head">
              <i class="el-icon-goods detail-section__icon detail-section__icon--goods"></i>
              <h3 class="detail-section__title">衣物明细</h3>
              <span class="detail-section__sub">共 {{ clothingData.length }} 件</span>
            </div>
            <div class="detail-section__body detail-section__body--table">
              <el-table
                :data="clothingData"
                size="small"
                max-height="280"
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
                tooltip-effect="dark"
              >
                <el-table-column type="index" width="50" label="#" />
                <el-table-column prop="productName" label="衣物名称" min-width="120" show-overflow-tooltip />
                <el-table-column prop="washingCode" label="水洗码" width="130" show-overflow-tooltip />
                <el-table-column prop="productAnnex" label="附件" width="100" show-overflow-tooltip />
                <el-table-column prop="productFlaw" label="瑕疵" width="100" show-overflow-tooltip />
                <el-table-column label="状态" width="110">
                  <template slot-scope="scope">
                    <div v-if="workList.orderType == 0">
                      <el-tag type="info" size="mini" v-if="scope.row.status == '0'">未入厂</el-tag>
                      <el-tag type="primary" size="mini" v-else-if="scope.row.status == '1'">已入厂</el-tag>
                      <el-tag type="warning" size="mini" v-else-if="scope.row.status == '2'">已分检</el-tag>
                      <el-tag type="success" size="mini" v-else-if="scope.row.status == '3'">已总检</el-tag>
                      <el-tag type="success" size="mini" v-else-if="scope.row.status == '4'">已出厂</el-tag>
                    </div>
                    <div v-else-if="workList.orderType == 1">{{ orderStatus(scope.row.status) }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="sortingTime" label="分检时间" width="160" show-overflow-tooltip />
                <el-table-column label="总检时间" width="160" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.giTime || scope.row.totalSelectionTime || "-" }}
                  </template>
                </el-table-column>
                <el-table-column prop="exFactoryTime" label="出厂时间" width="160" show-overflow-tooltip />
                <el-table-column label="图片" width="80">
                  <template slot-scope="scope">
                    <el-image
                      v-if="scope.row.productPic"
                      class="cloth-thumb"
                      :src="scope.row.productPic"
                      fit="cover"
                      @click.native="getImage(scope.row)"
                    />
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </section>

          <!-- 工单信息 -->
          <section class="detail-section">
            <div class="detail-section__head">
              <i class="el-icon-s-order detail-section__icon detail-section__icon--work"></i>
              <h3 class="detail-section__title">工单信息</h3>
              <div class="detail-section__actions" v-if="roleType">
                <el-button
                  v-if="orderData.wxAmount && orderData.openId"
                  type="success"
                  size="mini"
                  @click="openWxRefundDialog"
                >微信退款</el-button>
                <el-button
                  v-if="orderData.balancelAmount"
                  type="warning"
                  size="mini"
                  @click="balanceClick"
                >余额退款</el-button>
              </div>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="3" size="small" border>
                <el-descriptions-item label="创建时间">
                  {{ workList.createTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="修改时间">
                  {{ workList.modifyTime || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="优先级">
                  <el-tag size="mini" type="primary" v-if="workList.priority == '1'">普通</el-tag>
                  <el-tag size="mini" type="danger" v-else-if="workList.priority == '2'">紧急</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="工单来源">
                  <el-tag type="primary" size="mini" v-if="workList.orderType == '0'">线上</el-tag>
                  <el-tag type="success" size="mini" v-else-if="workList.orderType == '1'">门店</el-tag>
                  <el-tag type="danger" size="mini" v-else-if="workList.orderType == '2'">商城</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="工单类型">
                  {{ workOrderStatus(workList.workType) }}
                </el-descriptions-item>
                <el-descriptions-item label="发起人">
                  {{ workList.promoterMan || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="处理人" :span="3">
                  {{ workList.handleMan || "-" }}
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <!-- 退款记录 -->
          <section class="detail-section detail-section--full" v-if="rechageData.length != 0">
            <div class="detail-section__head">
              <i class="el-icon-money detail-section__icon detail-section__icon--money"></i>
              <h3 class="detail-section__title">退款记录</h3>
            </div>
            <div class="detail-section__body detail-section__body--table">
              <el-table
                :data="rechageData"
                size="small"
                border
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column prop="createTime" label="退款时间" min-width="160" />
                <el-table-column label="退款金额" width="120">
                  <template slot-scope="scope">
                    {{ formatNumber(scope.row.amount) }}
                  </template>
                </el-table-column>
                <el-table-column label="退款方式" width="100">
                  <template slot-scope="scope">
                    <el-tag type="success" size="mini" v-if="scope.row.reType == 2">微信</el-tag>
                    <el-tag type="warning" size="mini" v-if="scope.row.reType == 1">余额</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="note" label="退款原因" min-width="140" show-overflow-tooltip />
                <el-table-column prop="operator" label="操作员" width="100" />
              </el-table>
            </div>
          </section>

          <!-- 补款记录 -->
          <section class="detail-section detail-section--full" v-if="supplData.length != 0">
            <div class="detail-section__head">
              <i class="el-icon-wallet detail-section__icon detail-section__icon--supply"></i>
              <h3 class="detail-section__title">补款记录</h3>
            </div>
            <div class="detail-section__body detail-section__body--table">
              <el-table
                :data="supplData"
                size="small"
                border
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column prop="createTime" label="补款时间" min-width="160" />
                <el-table-column prop="phone" label="手机号" width="120" />
                <el-table-column label="补款金额" width="120">
                  <template slot-scope="scope">
                    {{ formatNumber(scope.row.amount) }}
                  </template>
                </el-table-column>
                <el-table-column label="补款状态" width="100">
                  <template slot-scope="scope">
                    <el-tag type="danger" size="mini" v-if="scope.row.status == 0">未支付</el-tag>
                    <el-tag type="success" size="mini" v-if="scope.row.status == 1">已支付</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="补款方式" width="100">
                  <template slot-scope="scope">
                    <el-tag type="success" size="mini" v-if="scope.row.supplyType == 1">微信</el-tag>
                    <el-tag type="warning" size="mini" v-if="scope.row.supplyType == 0">余额</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="二维码" width="90">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="handleCode(scope.row)">生成</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="note" label="补款原因" min-width="120" show-overflow-tooltip />
                <el-table-column prop="operator" label="操作员" width="100" />
              </el-table>
            </div>
          </section>

          <!-- 处理信息 -->
          <section class="detail-section detail-section--last detail-section--full">
            <div class="detail-section__head">
              <i class="el-icon-edit-outline detail-section__icon detail-section__icon--edit"></i>
              <h3 class="detail-section__title">处理信息</h3>
            </div>
            <div class="detail-section__body">
              <el-form label-width="88px" size="small" class="work-handle-form">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="处理人">
                      <el-select
                        v-model="workCreate.handleMan"
                        placeholder="请选择"
                        filterable
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in manOptions"
                          :key="item.id"
                          :label="item.nickname || item.username"
                          :value="item.nickname || item.username"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="优先级">
                      <el-radio-group v-model="workCreate.priority">
                        <el-radio :label="1">普通</el-radio>
                        <el-radio :label="2">紧急</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="状态">
                      <el-radio-group v-model="workCreate.status">
                        <el-radio :label="0">待处理</el-radio>
                        <el-radio :label="2">已完成</el-radio>
                        <el-radio :label="3">已拒绝</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="工单备注">
                  <el-input
                    type="textarea"
                    :rows="4"
                    v-model="workCreate.handleNote"
                    placeholder="处理备注"
                  />
                </el-form-item>
                <el-form-item label="处理图片">
                  <div class="work-pic-panel">
                    <div class="work-pic-upload">
                      <input type="file" @change="onFileChange" multiple accept="image/*" />
                      <span class="work-pic-tip">支持多选上传</span>
                    </div>
                    <ul class="work-pic-list" v-if="workListPic.length">
                      <li
                        class="work-pic-item"
                        v-for="(imageUrl, index) in workListPic"
                        :key="index"
                      >
                        <el-image
                          class="work-pic-thumb"
                          :src="imageUrl"
                          fit="cover"
                          :preview-src-list="workListPic"
                        />
                        <i @click="deleteImgWork(imageUrl)" class="el-icon-close work-pic-remove"></i>
                      </li>
                    </ul>
                    <div v-else class="work-pic-empty">暂无处理图片</div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </section>
        </div>
      </div>

      <span slot="footer" class="dialog-footer work-dialog-footer">
        <el-button @click="handleBack" size="small">返 回</el-button>
        <template v-if="roleType">
          <el-button type="warning" size="small" @click="balancediag">余额补款</el-button>
          <el-button type="success" size="small" @click="wxAmountDiag">微信补款</el-button>
        </template>
        <el-button
          type="primary"
          size="small"
          :loading="isSubmitting"
          @click="handleWorkSubmit()"
        >提 交</el-button>
      </span>
    </el-dialog>
    <!-- 大图预览 -->
    <div class="modal" v-if="showViewer">
      <el-image-viewer :on-close="closeViewer" :url-list="viewerImgList" style="z-index:9999"></el-image-viewer>
    </div>
    <!-- 微信退款弹框 -->
    <el-dialog
      custom-class="custom-wx-dialog"
      title="微信退款"
      :visible.sync="dialogVisibleWx"
      width="20%"
      center
    >
      <el-form :rules="rules" :model="wxChatObj" ref="workWxRef" label-width="100px" size="small">
        <el-form-item label="退款金额" prop="refundTotal">
          <el-input-number
            v-model="wxChatObj.refundTotal"
            controls-position="right"
            :min="0"
            :max="99999"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="退款原因" prop="note">
          <el-input v-model="wxChatObj.note" placeholder="请输入退款原因"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleWx = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogWx" :loading="submitLock.wxRefund" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 余额退款弹框 -->
    <el-dialog
      custom-class="custom-balance-dialog"
      title="用户余额退款"
      :visible.sync="dialogVisibleBalance"
      width="20%"
      center
    >
      <el-form
        :rules="rule"
        :model="balanceObj"
        ref="workBalanceRef"
        label-width="100px"
        size="small"
      >
        <el-form-item label="退款金额" prop="amount">
          <el-input-number
            v-model="balanceObj.amount"
            controls-position="right"
            :min="0"
            :max="99999"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="退款原因" prop="note">
          <el-input v-model="balanceObj.note" placeholder="请输入退款原因"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBalance = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogBalance" :loading="submitLock.balanceRefund" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 余额补款弹框：append-to-body 避免嵌套在主工单弹框内时遮罩层异常导致无法关闭 -->
    <el-dialog
      custom-class="supp-balance-dialog"
      title="用户余额补款"
      :visible.sync="dialogVisibleSupp"
      width="520px"
      append-to-body
    >
      <div class="supp-balance-body">
        <section class="supp-balance-section">
          <div class="supp-balance-section__head">
            <i class="el-icon-user"></i>
            <span>用户查询</span>
          </div>
          <el-form size="small" label-width="88px" @submit.native.prevent="userSearchPhone">
            <el-form-item label="手机号">
              <div class="supp-balance-search">
                <el-input
                  v-model="phoneNumber"
                  placeholder="请输入手机号"
                  clearable
                  maxlength="11"
                  @keyup.enter.native="userSearchPhone"
                ></el-input>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  :loading="phoneSearchLoading"
                  @click="userSearchPhone"
                >搜索</el-button>
              </div>
            </el-form-item>
          </el-form>
          <div
            class="supp-balance-user-card"
            :class="{ 'is-empty': !safeUserForm.phone }"
          >
            <div class="supp-balance-user-card__item">
              <span class="label">渠道</span>
              <span class="value">{{ safeUserForm.channelName || "-" }}</span>
            </div>
            <div class="supp-balance-user-card__item">
              <span class="label">昵称</span>
              <span class="value">{{ safeUserForm.nickname || "-" }}</span>
            </div>
            <div class="supp-balance-user-card__item">
              <span class="label">手机号</span>
              <span class="value">{{ safeUserForm.phone || "-" }}</span>
            </div>
            <div class="supp-balance-user-card__item supp-balance-user-card__item--balance">
              <span class="label">余额</span>
              <span class="value">{{ safeUserForm.balance != null ? safeUserForm.balance : "-" }}</span>
            </div>
          </div>
        </section>

        <section class="supp-balance-section">
          <div class="supp-balance-section__head">
            <i class="el-icon-wallet"></i>
            <span>补款信息</span>
          </div>
          <el-form
            :model="suppBalanceObj"
            ref="workBalanceRefSupp"
            label-width="88px"
            size="small"
          >
            <el-form-item label="补款金额" prop="amount">
              <el-input-number
                v-model="suppBalanceObj.amount"
                controls-position="right"
                :min="0"
                :max="99999"
                :precision="2"
                class="supp-balance-amount"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="订单编号" prop="orderSn">
              <el-input v-model="suppBalanceObj.orderSn" disabled></el-input>
            </el-form-item>
            <el-form-item label="补款原因" prop="note">
              <el-input
                v-model="suppBalanceObj.note"
                type="textarea"
                :rows="2"
                placeholder="请输入补款原因"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </section>
      </div>
      <span slot="footer" class="dialog-footer supp-balance-footer">
        <el-button @click="dialogVisibleSupp = false" size="small">取 消</el-button>
        <el-button type="primary" @click="dialogSuppBtn" :loading="submitLock.balanceSupp" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 微信补款弹框 -->
    <el-dialog
      custom-class="supp-wx-dialog"
      title="微信补款"
      :visible.sync="dialogVisibleSuppWx"
      width="40%"
      center
    >
      <el-form :model="suppWxObj" ref="workBalanceWXRefSupp" label-width="100px" size="small">
        <el-form-item label="补款金额" prop="amount">
          <el-input-number
            v-model="suppWxObj.amount"
            controls-position="right"
            :min="0"
            :max="99999"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="suppWxObj.phone"></el-input>
        </el-form-item>
        <el-form-item label="订单编号" prop="orderSn">
          <el-input v-model="suppWxObj.orderSn"></el-input>
        </el-form-item>
        <el-form-item label="补款原因" prop="note">
          <el-input v-model="suppWxObj.note" placeholder="请输入补款原因"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSuppWx = false" size="small">取 消</el-button>
        <el-button type="primary" @click="dialogSuppBtnWX" :loading="submitLock.wxSupp" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 微信补款二维码 -->
    <el-dialog
      custom-class="supp-wx-code-dialog"
      title="微信补款二维码"
      :visible.sync="wxCodeDialog"
      width="20%"
      center
    >
      <QrCodePrepay :qrcodeValue="wxSupplyCode"></QrCodePrepay>
    </el-dialog>
    <!-- 订单详情弹框 -->
    <OrderDetails :visible.sync="dialogVisible" :my-order="orderData"></OrderDetails>
    <OfflineDetails :visible.sync="dialogOffline" :my-order="orderData"></OfflineDetails>
    <SmallDetails :visible.sync="dialogSmall" :my-order="orderData"></SmallDetails>
  </div>
</template>

<script>
// 订单号查询订单、修改工单、订单查询子项、工单列举图片、post上传工单图片、get删除工单图片、微信退款、修改订单、微信补款预支付
import {
  getOrderSn,
  updateOrderWork,
  orderItem,
  listFileWork,
  uploadFilesWork,
  deleteFileWork,
  orderRefund,
  updateOrder,
  orderPrepay
} from "@/api/order.js";
// 水洗码获取衣物、列举图片、修改衣物
import {
  orderItemByWashingCode,
  listFile,
  updateOrderItem
} from "@/api/product.js";
import { getOrderSnOffline } from "@/api/store.js";
// 查询商城订单、修改用户余额、新增交易记录、交易记录列表、通过storeOpenId获取门店用户、通过onlineOpenId获取线上用户、通过phone和openId查询用户、手机号查询用户、新增补款记录、查询补款列表
import {
  getOrderSnSmall,
  updateMember,
  insertRecharge,
  getRecharge,
  getStoreOpenId,
  getOnlineOpenId,
  getPhoneOpenId,
  getUserPhone,
  insertSupply,
  supplyList,
  refundWxSend
} from "@/api/mall.js";
// 获取用户列表(不分页)
import { getUser } from "@/api/power.js";
import { cal } from "@/unit/cal.js";
import { mapMutations } from "vuex";
// 压缩图片插件
import Compressor from "compressorjs";
import { randomString } from "@/unit/random.js";
// 生成图片name
import { picString } from "@/unit/timestemp.js";
import { getCookie } from "@/unit/cookie";
// 线上订单详情弹框
import OrderDetails from "@/components/order/OrderDetails.vue";
// 门店订单详情弹框
import OfflineDetails from "@/components/offline/OrderDetails.vue";
// 商城订单详情弹框
import SmallDetails from "@/components/small/OrderDetails.vue";
// 生成二维码
import QrCodePrepay from "@/components/jsbarcode/qrCode.vue";
// 补款记录
const defaultSupply = {
  orderSn: "", //订单号
  channelId: null, //渠道id
  channelName: "", //渠道名称
  stageId: null, //门店id
  stageName: "", //门店名称
  phone: "", //手机号
  paySn: "", //支付单号
  amount: 0, //补款金额
  status: 0, //0未支付；1已支付
  payOpenId: "", //openID
  note: "", //补款原因
  supplyType: null, //0为余额；1为微信，补款方式
  sourceType: null, //来源平台,0:线上；1.门店；
  conType: null, //0衣物；1小商品；2兑换
  operator: "", //操作员
  type: null, //1、充值；2消费；3退款；4补款
  codeUrl: "" //微信补款二维码地址
};
// 微信推送
const defaultWxMess = {
  openId: "", //订单openID
  orderSn: "", //订单编号
  productName: "", //订单商品名称
  refundAmount: null, //退款金额
  type: null //线上退款传1，线下退款传2
};
// 余额退款对象
const defaultBalanceObj = {
  note: "", //退款原因
  amount: 0 //退款金额
};
const defaultWxChatObj = {
  loginType: "",
  note: "", //退款原因
  refundType: null, // MAIN / SMALL_PRODUCT，禁止传空串（后端枚举无法反序列化）
  phone: "", //手机号
  refundTotal: 0 //退款金额
};
export default {
  components: {
    // quillEditor,
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer.vue"),
    OrderDetails,
    OfflineDetails,
    SmallDetails,
    QrCodePrepay
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 传整个工单对象
    myWork: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isSubmitting: false,
      // 各财务操作独立提交锁，避免共用一个 isClicked 导致互锁（关弹窗才能恢复）
      submitLock: {
        balanceRefund: false, // 余额退款
        wxRefund: false, // 微信退款
        balanceSupp: false, // 余额补款
        wxSupp: false // 微信补款
      },
      rechageData: [], //交易记录
      workDialogVisible: this.visible,
      workList: this.myWork, //工单对象
      workCreate: {},
      orderData: {}, //订单对象
      dialogVisible: false, //线上订单详情弹框
      dialogOffline: false, //门店订单详情弹框
      dialogSmall: false, //商城订单详情弹框
      // 衣物列表
      clothingData: [],
      // 大图
      showViewer: false,
      viewerImgList: [],
      // 获取处理人
      manOptions: [],
      // 工单处理图片列举
      workListPic: [],
      // 上传工单图片
      workPic: {
        file: "",
        ossFolderName: ""
      },
      // 微信退款传参
      wxChatObj: Object.assign({}, defaultWxChatObj),
      conTypeRecharg: null, //0衣物；1小商品；2兑换
      sourceRecharg: null, //来源平台,0:线上；1.门店；
      // 余额退款对象
      balanceObj: Object.assign({}, defaultBalanceObj),
      roleType: 0, //判断工厂用户是否有退款权限
      amountAll: 0, //多次余额退款的金额总和
      dialogVisibleWx: false,
      dialogVisibleBalance: false, //余额退款弹框
      dialogVisibleSupp: false, //余额补款弹框
      suppBalanceObj: Object.assign({}, defaultSupply),
      wxRefundBalance: Object.assign({}, defaultWxMess),
      dialogVisibleSuppWx: false, //微信补款弹框
      wxCodeDialog: false, //微信补款二维码弹框
      wxSupplyCode: "", //微信支付地址code
      suppWxObj: Object.assign({}, defaultSupply),
      phoneNumber: "", //手机号用来搜索用户信息
      phoneSearchLoading: false, // 余额补款手机号搜索 loading
      userForm: {}, //用户信息
      userObj: {}, //手机号查询用户信息（退款操作）
      supplData: [], //补款记录列表
      // isWxChat: false, //是否显示微信退款按钮
      rules: {
        refundTotal: [
          { required: true, message: "请输入退款金额", trigger: "blur" },
          { validator: this.validateQuantity, trigger: "blur" }
        ],
        note: [{ required: true, message: "请输入退款原因", trigger: "blur" }]
      },
      rule: {
        amount: [
          { required: true, message: "请输入退款金额", trigger: "blur" },
          { validator: this.validateQuantity, trigger: "blur" }
        ],
        note: [{ required: true, message: "请输入退款原因", trigger: "blur" }]
      }
    };
  },
  watch: {
    dialogVisibleBalance(newVal) {
      if (!newVal) {
        this.submitLock.balanceRefund = false;
      }
    },
    dialogVisibleSupp(newVal) {
      if (!newVal) {
        this.submitLock.balanceSupp = false;
      }
    },
    dialogVisibleWx(newVal) {
      if (!newVal) {
        this.submitLock.wxRefund = false;
        this.wxChatObj.note = "";
        this.wxChatObj.refundTotal = 0;
      }
    },
    dialogVisibleSuppWx(newVal) {
      if (!newVal) {
        this.submitLock.wxSupp = false;
      }
    },
    visible(newValue) {
      console.log("new", newValue);
      this.workDialogVisible = newValue;
      if (newValue) {
        this.workList = this.myWork;
        this.workCreate = JSON.parse(JSON.stringify(this.myWork));
        this.workCreate.handleMan =
          getCookie("nickname") || getCookie("username");
        this.roleType = getCookie("type");
        if (this.myWork.orderType == 0) {
          this.conTypeRecharg = 0;
          this.sourceRecharg = 0;
          this.getOrderSn(this.myWork.orderSn);
          if (this.myWork.washingCode) {
            let arr = this.myWork.washingCode.split(",");
            arr.forEach(item => {
              this.orderItemByWashingCode(item);
            });
          } else {
            this.getOrderItem(this.myWork.orderSn);
          }
        } else if (this.myWork.orderType == 2) {
          this.conTypeRecharg = 1;
          this.getOrderSnSmall(this.myWork.orderSn);
        } else if (this.myWork.orderType == 1) {
          this.conTypeRecharg = 0;
          this.sourceRecharg = 1;
          this.getOrderSnOffline(this.myWork.orderSn);
        }
        this.workPic.ossFolderName = this.workList.ossFolderName;
        console.log(this.workList);
        this.getUser();
        // 获取补款记录
        this.suppDataList();
        this.workImgList(this.workList.ossFolderName);
      }
    }
  },
  filters: {
    formatStatus(value) {
      if (value === 0) {
        return "待处理";
      } else if (value === 2) {
        return "已完成";
      } else if (value === 3) {
        return "已拒绝";
      }
    }
  },
  computed: {
    // 保证 userForm 始终为对象，避免搜索失败赋 null 后模板报错导致弹框无法关闭
    safeUserForm() {
      return this.userForm && typeof this.userForm === "object" ? this.userForm : {};
    }
  },
  created() {},
  mounted() {},
  methods: {
    formatNumber(amount) {
      return Number(amount).toFixed(2);
    },
    /** 按工单 orderType 补全微信退款所需 loginType / refundType（禁止空串） */
    applyWxRefundContext(order) {
      const data = order || this.orderData || {};
      const orderType = Number(
        this.workList && this.workList.orderType != null
          ? this.workList.orderType
          : this.myWork && this.myWork.orderType
      );
      if (orderType === 2) {
        this.wxChatObj.refundType = "SMALL_PRODUCT";
        const platform =
          data.type != null && data.type !== ""
            ? data.type
            : this.sourceRecharg;
        this.wxChatObj.loginType = platform ? "STORE" : "ONLINE";
        this.wxChatObj.phone = data.phone || this.wxChatObj.phone || "";
        return;
      }
      this.wxChatObj.refundType = "MAIN";
      this.wxChatObj.loginType =
        orderType === 1 || this.sourceRecharg ? "STORE" : "ONLINE";
      if (data.phone) {
        this.wxChatObj.phone = data.phone;
      }
    },
    openWxRefundDialog() {
      this.applyWxRefundContext(this.orderData);
      this.wxChatObj.note = "";
      this.wxChatObj.refundTotal = 0;
      this.dialogVisibleWx = true;
      this.$nextTick(() => {
        if (this.$refs.workWxRef) {
          this.$refs.workWxRef.clearValidate();
        }
      });
    },
    // 点击订单编号文字链接弹框线上订单详情
    async getOrderClick(row) {
      if (this.workList.orderType == 0) {
        this.dialogVisible = true;
      } else if (this.workList.orderType == 1) {
        this.dialogOffline = true;
        // 门店详情
      } else if (this.workList.orderType == 2) {
        // 商城订单详情
        this.dialogSmall = true;
      }
      this.orderData = row;
      console.log(row);
    },
    // 订单号查询门店订单
    async getOrderSnOffline(orderSn) {
      this.orderData = {};
      this.clothingData = [];
      const { data: res } = await getOrderSnOffline(orderSn);
      if (res.code === 200) {
        this.orderData = res.data;
        // 获取退款记录
        this.getRechargeList({ paySn: res.data.paySn, type: 3 }, false);
        // 订单衣物
        this.clothingData = [...this.clothingData, res.data];
        this.applyWxRefundContext(res.data);
      }
    },
    // 订单号查询商城订单
    async getOrderSnSmall(orderSn) {
      this.orderData = {};
      this.clothingData = [];
      const { data: res } = await getOrderSnSmall(orderSn);
      if (res.code === 200) {
        this.orderData = res.data;
        // this.conTypeRecharg = 1;
        this.sourceRecharg = res.data.type;
        // 获取退款记录
        this.getRechargeList({ paySn: res.data.paySn, type: 3 }, false);
        this.applyWxRefundContext(res.data);
      }
    },
    // 订单号查询线上订单
    async getOrderSn(orderSn) {
      this.orderData = {};
      this.clothingData = [];
      const { data: res } = await getOrderSn(orderSn);
      if (res.code === 200) {
        this.orderData = res.data;
        // 获取退款记录
        this.getRechargeList(
          { paySn: res.data.paySn || res.data.orderSn, type: 3 },
          false
        );
        this.applyWxRefundContext(res.data);
      }
    },
    // 余额退款——打开弹窗前拉取已退金额
    async balanceClick() {
      this.amountAll = 0;
      this.balanceObj = Object.assign({}, defaultBalanceObj);
      this.dialogVisibleBalance = true;
      const obj = {
        paySn: this.orderData.paySn || this.orderData.orderSn,
        type: 3, //1:充值；2：消费；3：退款；4：补款
        reType: 1 //1:用户退款/余额退款；2管理员退款/微信退款
      };
      await this.getRechargeList(obj, true);
    },
    /**
     * 获取退款/交易记录
     * @param {boolean} isBtn 为 true 时累加余额退款总额 amountAll（使用 cal 精确计算）
     * @returns {boolean} 接口是否成功（失败时不应依赖 amountAll 做上限判断）
     */
    async getRechargeList(obj, isBtn) {
      try {
        const { data: res } = await getRecharge(obj);
        if (res.code !== 200) {
          if (isBtn) {
            this.amountAll = 0;
            this.$message.error(res.message || "获取退款记录失败");
          }
          return false;
        }
        const arr = res.data.list;
        this.rechageData = arr || [];
        if (isBtn) {
          // 使用 cal.jia 累加，避免浮点误差导致超限判断失真
          this.amountAll = 0;
          if (arr && arr.length) {
            arr.forEach(item => {
              this.amountAll = Number(
                cal.jia(this.amountAll, item.amount || 0)
              );
            });
          }
        }
        return true;
      } catch (e) {
        if (isBtn) {
          this.amountAll = 0;
          this.$message.error("获取退款记录失败，请稍后重试");
        }
        return false;
      }
    },
    // 余额退款确定按钮
    handleDialogBalance() {
      const orderObj = JSON.parse(JSON.stringify(this.orderData));
      this.wxRefundBalance = Object.assign({}, defaultWxMess);

      this.$refs.workBalanceRef.validate(async valid => {
        if (!valid) {
          return this.$message.error("请填写必要的表单项！");
        }
        if (this.submitLock.balanceRefund) {
          return;
        }
        // 提交前重新拉取已退金额，避免打开弹窗后并发退款或首次拉取失败导致上限不准
        const listOk = await this.getRechargeList(
          {
            paySn: orderObj.paySn || orderObj.orderSn,
            type: 3,
            reType: 1
          },
          true
        );
        if (!listOk) {
          return;
        }
        const sum = Number(cal.jia(this.amountAll, this.balanceObj.amount));
        const balanceLimit = Number(orderObj.balancelAmount || 0);
        if (sum > balanceLimit) {
          return this.$message.error("退款金额已经超过支付金额!");
        }
        this.submitLock.balanceRefund = true;
        await this.getPhoneUser(orderObj);
      });
    },
    // 通过手机号查询用户；失败时必须释放 balanceRefund 锁，否则无法再次提交
    async getPhoneUser(order) {
      if (!order.phone) {
        this.$message.error("订单缺少用户手机号，无法退款");
        this.submitLock.balanceRefund = false;
        return;
      }
      try {
        const { data: res } = await getUserPhone(order.phone);
        if (res.code === 200 && res.data) {
          this.userObj = res.data;
          const user = JSON.parse(JSON.stringify(res.data));
          await this.getRefund(user, order);
        } else {
          this.$message.error((res && res.message) || "未找到该手机号对应的用户");
          this.submitLock.balanceRefund = false;
        }
      } catch (e) {
        this.$message.error("查询用户失败，请稍后重试");
        this.submitLock.balanceRefund = false;
      }
    },
    // 通过手机号和openid查询用户
    async getPhoneAndOpenid(loginType, order) {
      const { data: res } = await getPhoneOpenId(
        loginType,
        order.openId,
        order.phone
      );
      if (res.code === 200 && res.data) {
        this.userObj = res.data;
        let user = JSON.parse(JSON.stringify(res.data));
        this.getRefund(user, order, true);
      }
    },
    // 线上订单查询用户(未使用)
    async getOnline(order) {
      // 1、点击余额退款获取用户对象
      const { data: res } = await getOnlineOpenId(order.openId);
      if (res.code === 200 && res.data) {
        this.userObj = res.data;
        let user = JSON.parse(JSON.stringify(res.data));
        this.getRefund(user, order, true);
      }
    },
    // 门店订单查询用户(未使用)
    async getStore(order) {
      // 1、点击余额退款获取用户对象
      const { data: res } = await getStoreOpenId(order.openId);
      if (res.code === 200) {
        // 如果通过门店openid获取到了用户
        if (res.data) {
          this.userObj = res.data;
          let user = JSON.parse(JSON.stringify(res.data));
          this.getRefund(user, order, true);
        } else {
          // 否则继续调转线上openId获取用户
          this.getOnline(order);
        }
      }
    },
    // 新增退款记录——余额退款修改用户余额
    async getRefund(user, data) {
      const originalBalance = user.balance;
      user.balance = cal.jia(user.balance, this.balanceObj.amount);
      const recharge = {
        amount: this.balanceObj.amount,
        openId: data.openId,
        memberName: data.memberUsername,
        operator: getCookie("nickname") || getCookie("username"),
        phone: user.phone,
        paySn: data.paySn,
        orderSn: data.orderSn,
        channelId: data.channelId,
        channelName: data.channelName,
        stageId: data.stageId,
        stageName: data.stageName,
        reType: 1,
        type: 3,
        note: this.balanceObj.note,
        memberBalance: user.balance,
        sourceType: this.sourceRecharg,
        conType: this.conTypeRecharg
      };
      await this.updateUserAmount(user, recharge, false, originalBalance);
    },
    /**
     * 微信退款确认：先校验表单再提交（修复原先关弹窗后校验导致表单丢失）
     * 流程：校验 → insertSupply → orderRefund；任一步失败均提示并释放 wxRefund 锁
     */
    async handleDialogWx() {
      if (this.submitLock.wxRefund) {
        return;
      }
      this.$refs.workWxRef.validate(async valid => {
        if (!valid) {
          return this.$message.error("请填写必要的表单项！");
        }
        this.submitLock.wxRefund = true;
        const orderObj = JSON.parse(JSON.stringify(this.orderData));
        this.applyWxRefundContext(orderObj);
        // 空串无法反序列化为 RefundType 枚举，提交前必须是 MAIN / SMALL_PRODUCT
        const refundType =
          this.wxChatObj.refundType && String(this.wxChatObj.refundType).trim()
            ? this.wxChatObj.refundType
            : null;
        const loginType =
          this.wxChatObj.loginType && String(this.wxChatObj.loginType).trim()
            ? this.wxChatObj.loginType
            : this.sourceRecharg
              ? "STORE"
              : "ONLINE";
        if (!refundType || !orderObj.paySn) {
          this.submitLock.wxRefund = false;
          return this.$message.error("订单支付信息不完整，无法发起微信退款");
        }
        const wxSuppRef = Object.assign({}, defaultSupply);
        const refund = {
          loginType,
          openId: orderObj.openId,
          orderSn: orderObj.orderSn,
          phone: this.wxChatObj.phone,
          paySn: orderObj.paySn,
          refundTotal: this.wxChatObj.refundTotal,
          refundType
        };
        wxSuppRef.orderSn = orderObj.orderSn;
        wxSuppRef.channelId = orderObj.channelId;
        wxSuppRef.channelName = orderObj.channelName;
        wxSuppRef.stageId = orderObj.stageId;
        wxSuppRef.stageName = orderObj.stageName;
        wxSuppRef.phone = orderObj.phone;
        wxSuppRef.paySn = orderObj.paySn;
        wxSuppRef.amount = this.wxChatObj.refundTotal;
        wxSuppRef.openId = orderObj.openId;
        wxSuppRef.note = this.wxChatObj.note;
        wxSuppRef.supplyType = 1;
        wxSuppRef.sourceType = this.sourceRecharg;
        wxSuppRef.conType = this.conTypeRecharg;
        wxSuppRef.type = 3;
        wxSuppRef.operator = getCookie("nickname") || getCookie("username");
        try {
          const { data: res } = await insertSupply(wxSuppRef);
          if (res.code !== 200) {
            this.$message.error(res.message || "退款记录写入失败");
            return;
          }
          const refundOk = await this.wxRefund(refund);
          if (refundOk) {
            this.dialogVisibleWx = false;
          } else {
            // supply 已写入但微信退款失败，需人工核对避免重复退款
            this.$message.warning(
              "微信退款失败，已生成待处理记录，请核对后重试或联系技术处理"
            );
            this.suppDataList();
          }
        } catch (e) {
          this.$message.error("微信退款操作失败，请稍后重试");
        } finally {
          this.submitLock.wxRefund = false;
        }
      });
    },
    /** 微信退款接口，返回是否成功 */
    async wxRefund(refund) {
      try {
        const res = await orderRefund(refund);
        if (res.data.code === 200) {
          this.$message.success("微信退款成功");
          setTimeout(() => {
            this.getRechargeList({ paySn: refund.paySn, type: 3 }, false);
          }, 1000);
          return true;
        }
        this.$message.error(res.data.message || "微信退款失败");
        return false;
      } catch (e) {
        this.$message.error("微信退款失败，请稍后重试");
        return false;
      }
    },
    /**
     * 余额退款/余额补款：先改用户余额，再写流水/补款记录
     * 修复：仅在流水写入成功后再提示成功并关弹窗；失败时尝试回滚余额
     * @param {*} originalBalance 操作前余额，用于回滚
     */
    async updateUserAmount(user, recharge, isSupp, originalBalance) {
      try {
        const uo = await updateMember(user);
        if (uo.data.code !== 200) {
          this.$message.error(uo.data.message || "修改用户余额失败");
          return;
        }
        if (isSupp) {
          const suppOk = await this.suppUpdate(recharge, false, user);
          if (!suppOk) {
            await this.rollbackMemberBalance(user, originalBalance);
            this.$message.error("补款记录写入失败，已回滚用户余额");
            return;
          }
          this.dialogVisibleSupp = false;
          this.$message.success("余额补款成功！");
        } else {
          const insertOk = await this.insertUpdate(recharge, true);
          if (!insertOk) {
            await this.rollbackMemberBalance(user, originalBalance);
            this.$message.error("退款交易记录写入失败，已回滚用户余额");
            return;
          }
          this.dialogVisibleBalance = false;
          this.$message.success("余额退款成功！");
          if (this.workList.orderType != 2) {
            this.wxMessage(recharge);
          }
        }
      } catch (e) {
        this.$message.error("操作失败，请稍后重试");
        if (originalBalance != null) {
          await this.rollbackMemberBalance(user, originalBalance);
        }
      } finally {
        if (isSupp) {
          this.submitLock.balanceSupp = false;
        } else {
          this.submitLock.balanceRefund = false;
        }
      }
    },
    /** 余额操作失败时回滚用户余额 */
    async rollbackMemberBalance(user, originalBalance) {
      try {
        await updateMember({ ...user, balance: originalBalance });
      } catch (e) {
        this.$message.error("余额回滚失败，请联系技术人员处理");
      }
    },
    async wxMessage(recharge) {
      this.wxRefundBalance.openId = this.orderData.openId;
      this.wxRefundBalance.orderSn = this.orderData.orderSn;
      this.wxRefundBalance.productName = this.orderData.productName;
      this.wxRefundBalance.refundAmount = recharge.amount;
      this.wxRefundBalance.type = this.sourceRecharg + 1; //来源平台0线上；1门店
      let obj = JSON.parse(JSON.stringify(this.wxRefundBalance));
      const { res: data } = await refundWxSend(obj);
    },
    /** 新增交易记录，返回是否成功 */
    async insertUpdate(recharge, isRech) {
      try {
        const { data: ress } = await insertRecharge(recharge);
        if (ress.code === 200) {
          if (isRech) {
            this.getRechargeList({ paySn: recharge.paySn, type: 3 }, false);
          } else {
            this.suppDataList();
          }
          return true;
        }
        this.$message.error(ress.message || "交易记录写入失败");
        return false;
      } catch (e) {
        this.$message.error("交易记录写入失败，请稍后重试");
        return false;
      }
    },
    /** 新增补款记录；微信补款时继续调预支付，返回整体是否成功 */
    async suppUpdate(recharge, isWxPrepay, user) {
      try {
        const { data: res } = await insertSupply(recharge);
        if (res.code !== 200) {
          this.$message.error(res.message || "补款记录写入失败");
          return false;
        }
        if (isWxPrepay) {
          return await this.getPrepay(recharge);
        }
        const data = {
          amount: recharge.amount,
          openId: this.orderData.openId,
          memberName: this.orderData.memberUsername,
          operator: getCookie("nickname") || getCookie("username"),
          phone: recharge.phone,
          paySn: this.orderData.paySn,
          orderSn: this.orderData.orderSn,
          channelId: this.orderData.channelId,
          channelName: this.orderData.channelName,
          stageId: this.orderData.stageId,
          stageName: this.orderData.stageName,
          reType: 1,
          type: 4,
          note: recharge.note,
          memberBalance: user.balance,
          sourceType: this.sourceRecharg,
          conType: this.conTypeRecharg
        };
        return await this.insertUpdate(data, false);
      } catch (e) {
        this.$message.error("补款记录写入失败，请稍后重试");
        return false;
      }
    },
    // 查询补款记录列表
    async suppDataList() {
      const { data: res } = await supplyList({
        orderSn: this.workList.orderSn,
        type: 4
      });
      if (res.code === 200) {
        this.supplData = res.data.list;
      }
    },
    // 余额补款按钮
    balancediag() {
      this.dialogVisibleSupp = true;
      this.userForm = {};
      this.phoneNumber = this.orderData.phone || "";
      this.suppBalanceObj = Object.assign({}, defaultSupply);
      this.suppBalanceObj.orderSn =
        this.workList.orderSn || this.orderData.orderSn;
    },
    // 手机号搜索：失败时必须保持 userForm 为空对象，否则模板渲染异常会导致弹框无法关闭
    async userSearchPhone() {
      if (!this.phoneNumber) {
        return this.$message.warning("请输入手机号");
      }
      if (this.phoneSearchLoading) {
        return;
      }
      this.phoneSearchLoading = true;
      try {
        const { data: res } = await getUserPhone(this.phoneNumber);
        if (res.code === 200 && res.data) {
          this.userForm = res.data;
        } else {
          this.userForm = {};
          this.$message.error(res.message || "未找到该手机号对应的用户");
        }
      } catch (e) {
        this.userForm = {};
        this.$message.error("查询用户失败，请稍后重试");
      } finally {
        this.phoneSearchLoading = false;
      }
    },
    // 余额补款弹框确认按钮
    async dialogSuppBtn() {
      this.suppBalanceObj.phone = this.phoneNumber;
      if (!this.validatePositiveAmount(this.suppBalanceObj.amount, "补款金额")) {
        return;
      }
      if (!this.userForm || this.userForm.balance == null) {
        return this.$message.error("请先搜索并确认用户信息");
      }
      if (this.submitLock.balanceSupp) {
        return;
      }
      if (Number(this.suppBalanceObj.amount) > Number(this.userForm.balance)) {
        return this.$message.error("余额补款金额不能超过用户余额！");
      }
      this.submitLock.balanceSupp = true;
      const user = JSON.parse(JSON.stringify(this.userForm));
      const originalBalance = user.balance;
      user.balance = cal.jian(this.userForm.balance, this.suppBalanceObj.amount);
      this.suppBalanceObj.status = 1;
      this.suppBalanceObj.type = 4;
      this.suppBalanceObj.channelId = this.orderData.channelId;
      this.suppBalanceObj.channelName = this.orderData.channelName;
      this.suppBalanceObj.stageName = this.orderData.stageName;
      this.suppBalanceObj.stageId = this.orderData.stageId;
      this.suppBalanceObj.operator =
        getCookie("nickname") || getCookie("username");
      this.suppBalanceObj.supplyType = 0;
      this.suppBalanceObj.sourceType = this.sourceRecharg;
      this.suppBalanceObj.conType = this.conTypeRecharg;
      this.suppBalanceObj.paySn = this.orderData.paySn;
      await this.updateUserAmount(
        user,
        this.suppBalanceObj,
        true,
        originalBalance
      );
    },
    // 补款二维码生成
    handleCode(row) {
      if (row.supplyType || row.codeUrl) {
        this.wxCodeDialog = true;
        // 微信补款二维码
        this.wxSupplyCode = row.codeUrl;
        console.log("微信补款二维码");
      } else {
        this.$message.error("余额补款不支持生成二维码！");
      }
    },
    // 重新生成微信补款二维码
    handleEdit(row) {},
    // 微信补款按钮
    wxAmountDiag() {
      this.dialogVisibleSuppWx = true;
      this.suppWxObj = Object.assign({}, defaultSupply);
      this.suppWxObj.orderSn = this.workList.orderSn;
      this.suppWxObj.channelId = this.orderData.channelId;
      this.suppWxObj.channelName = this.orderData.channelName;
      this.suppWxObj.stageId = this.orderData.stageId;
      this.suppWxObj.stageName = this.orderData.stageName;
      this.suppWxObj.phone = this.orderData.phone;
      this.suppWxObj.payOpenId = this.orderData.openId;
    },
    // 微信补款确认按钮——先新增 supply 表，再调用微信预支付接口
    async dialogSuppBtnWX() {
      if (!this.validatePositiveAmount(this.suppWxObj.amount, "补款金额")) {
        return;
      }
      if (this.submitLock.wxSupp) {
        return;
      }
      this.submitLock.wxSupp = true;
      const paySn = "BK-" + picString(20);
      this.suppWxObj.paySn = paySn;
      this.suppWxObj.status = 0;
      this.suppWxObj.supplyType = 1;
      this.suppWxObj.type = 4;
      this.suppWxObj.operator =
        getCookie("nickname") || getCookie("username");
      this.suppWxObj.sourceType = this.sourceRecharg;
      this.suppWxObj.conType = this.conTypeRecharg;
      try {
        const ok = await this.suppUpdate(this.suppWxObj, true, null);
        if (!ok) {
          // supply 可能已写入但预支付失败，刷新列表便于核对
          this.suppDataList();
        }
      } catch (e) {
        this.$message.error("微信补款失败，请稍后重试");
      } finally {
        this.submitLock.wxSupp = false;
      }
    },
    /** 微信预支付；失败时提示，锁由 dialogSuppBtnWX.finally 统一释放 */
    async getPrepay(data) {
      try {
        const type = this.sourceRecharg ? "STORE" : "ONLINE";
        const rechage = {
          paySn: data.paySn,
          totalFee: data.amount,
          tradeTypeEnum: "NATIVE",
          loginType: type,
          productName: this.orderData.productName
        };
        const { data: res } = await orderPrepay(rechage);
        if (res.code === 200) {
          this.dialogVisibleSuppWx = false;
          this.suppDataList();
          setTimeout(() => {
            this.wxCodeDialog = true;
            this.wxSupplyCode = res.data.apiResult;
          });
          return true;
        }
        this.$message.error(res.message || "微信预支付失败");
        return false;
      } catch (e) {
        this.$message.error("微信预支付失败，请稍后重试");
        return false;
      }
    },
    // 水洗码查询衣物子项(这个地方需改为不改状态的接口)
    // 以逗号隔开多个水洗码循环获取
    async orderItemByWashingCode(washingCode) {
      this.clothingData = [];
      const { data: res } = await orderItemByWashingCode(washingCode);
      if (res.code === 200 && !!res.data) {
        this.clothingData.push(res.data);
      }
    },
    // 订单查询子项
    async getOrderItem(orderSn) {
      this.clothingData = [];
      const { data: res } = await orderItem(orderSn);
      if (res.code === 200 && !!res.data) {
        this.clothingData = res.data;
      }
    },
    // 点击大图关闭
    closeViewer() {
      this.showViewer = false;
    },
    // 点击查看图片出现大图预览
    async getImage(row) {
      this.viewerImgList = [];
      await listFile(row.ossFolderName).then(res => {
        if (res.data.code === 200) {
          let arr = res.data.data;
          for (let i = 0; i < arr.length; i++) {
            let parts = arr[i].split("?");
            if (parts.length > 1) {
              this.viewerImgList.push(parts[0]);
            }
          }
          this.showViewer = true;
          console.log("tup", this.viewerImgList);
        }
      });
    },
    // 工单选择图片
    onFileChange(e) {
      const fileData = e.target.files;
      for (let i = 0; i < fileData.length; i++) {
        const name = `${picString(20)}.jpeg`;
        new Compressor(fileData[i], {
          quality: 0.6,
          success: result => {
            let files = new File([result], name, {
              type: "image/jpeg",
              lastModified: Date.now()
            });
            this.workPic.file = files;
            console.log("file", this.workPic);
            uploadFilesWork(this.workPic).then(res => {
              if (res.data.code === 200) {
                this.workListPic.push(res.data.data);
              }
            });
          }
        });
      }
      console.log(e);
    },
    /**
     * 表单金额校验：拒绝空值、非数字、0 及负数
     * （修复原先仅判断 == 0 的漏洞）
     */
    validateQuantity(rule, value, callback) {
      if (value === null || value === undefined || value === "") {
        callback(new Error("请输入金额"));
        return;
      }
      const num = Number(value);
      if (Number.isNaN(num) || num <= 0) {
        callback(new Error("金额必须大于0"));
        return;
      }
      callback();
    },
    /** 补款等无 form validator 场景的金额校验 */
    validatePositiveAmount(amount, label = "金额") {
      if (amount === null || amount === undefined || amount === "") {
        this.$message.error(`请输入${label}`);
        return false;
      }
      const num = Number(amount);
      if (Number.isNaN(num) || num <= 0) {
        this.$message.error(`${label}必须大于0`);
        return false;
      }
      return true;
    },
    // 删除图片
    deleteImgWork(file) {
      const parts = file.split(".com/");
      let data = {
        filePath: parts[1]
      };
      this.$confirm("确定删除该照片？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(data);
          deleteFileWork(data)
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.workImgList(this.workPic.ossFolderName);
              }
            })
            .catch(() => {
              return this.$message.error("删除失败");
            });
        })
        .catch(() => {
          return this.$message.info("已取消删除");
        });
    },
    // 工单图片列举
    workImgList(ossFolderName) {
      this.workListPic = [];
      listFileWork(ossFolderName).then(res => {
        if (res.data.code === 200) {
          let arr = res.data.data;
          for (let i = 0; i < arr.length; i++) {
            let parts = arr[i].split("?");
            if (parts.length > 1) {
              this.workListPic.push(parts[0]);
            }
          }
        }
      });
    },
    // 提交
    handleWorkSubmit() {
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      updateOrderWork(this.workCreate)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$emit("refreshWork", true);
            this.workDialogVisible = false;
            this.$message.success("提交成功!");
          } else {
            this.$message.error(
              (res.data && res.data.message) || "提交失败!",
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("提交失败，请稍后重试");
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    handleBack() {
      this.workDialogVisible = false;
      this.$emit("refreshWork", false);
    },
    // 获取用户列表
    async getUser() {
      this.manOptions = [];
      const { data: res } = await getUser();
      // console.log('yh', res)
      if (res.code === 200) {
        this.manOptions = res.data;
      }
    },
    // 工单类型
    workOrderStatus(v) {
      //类型:1->订单异常；2->售后；3->漏补发；4->催单；5->投诉；6->个人业务；7->疑似丢件；8->退款；9->数量不符;10->补款;11->退洗
      switch (v) {
        case 1:
          return "订单异常";
        case 2:
          return "售后";
        case 3:
          return "漏补发";
        case 4:
          return "催单";
        case 5:
          return "投诉";
        case 6:
          return "个人业务";
        case 7:
          return "疑似丢件";
        case 8:
          return "退款";
        case 9:
          return "数量不符";
        case 10:
          return "补款";
        case 11:
          return "退洗";
        default:
          return "";
      }
    },
    // 门店订单状态
    orderStatus(v) {
      //状态:0->已付款；1->待送件；2->已收衣（门店）；3->已取件（物流）；4->已分检；5->已总检;6->已出库；7->净衣到店（物流）；8->净衣入库（门店）；9->完成；10->取消；11->已拒单
      switch (v) {
        case 0:
          return "已付款";
        case 1:
          return "待送件";
        case 2:
          return "门店已收衣";
        case 3:
          return "已取件(物流)";
        case 4:
          return "已分检";
        case 5:
          return "已总检";
        case 6:
          return "已出库(在途)";
        case 7:
          return "已到店";
        case 8:
          return "已入库";
        case 9:
          return "已完成(已取衣)";
        case 10:
          return "已取消";
        case 11:
          return "已拒单";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped lang="less">
// append-to-body 弹框不在 .workDetails 内，样式需直接挂载 custom-class
/deep/ .supp-balance-dialog {
  .el-dialog__body {
    padding: 16px 20px 8px;
  }

  .supp-balance-body {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .supp-balance-section {
    background: #f8fafc;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px 4px;
  }

  .supp-balance-section__head {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;

    i {
      color: #409eff;
      font-size: 16px;
    }
  }

  .supp-balance-search {
    display: flex;
    align-items: center;
    gap: 10px;

    .el-input {
      flex: 1;
    }
  }

  .supp-balance-user-card {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px 16px;
    margin: 0 0 8px;
    padding: 12px 14px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 6px;

    &.is-empty .value {
      color: #c0c4cc;
    }

    &__item {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-width: 0;

      .label {
        font-size: 12px;
        color: #909399;
        line-height: 1.2;
      }

      .value {
        font-size: 14px;
        color: #303133;
        line-height: 1.4;
        word-break: break-all;
      }

      &--balance .value {
        color: #e6a23c;
        font-weight: 600;
      }
    }
  }

  .supp-balance-amount {
    width: 100%;
  }

  .supp-balance-footer {
    padding-top: 4px;
  }

  .el-form-item {
    margin-bottom: 14px;
  }

  .el-input.is-disabled .el-input__inner {
    color: #606266;
    background: #f5f7fa;
  }
}

.workDetails {
  /deep/ .supp-wx-code-dialog {
    .el-dialog__body {
      .qrCode {
        justify-content: center;
      }
    }
  }
  /deep/ .custom-wx-dialog {
    margin-top: 35vh !important;
  }
  /deep/ .custom-balance-dialog {
    margin-top: 35vh !important;
  }
}

.work-dialog__title-main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.work-dialog__sn {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.work-detail-body {
  background: #f5f7fa;
}

.work-status-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 14px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 8px;
  color: #f56c6c;
  font-size: 14px;
  font-weight: 500;

  i {
    font-size: 18px;
  }

  &--success {
    background: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }

  &--danger {
    background: #fef0f0;
    border-color: #fde2e2;
    color: #f56c6c;
  }
}

.work-summary {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;

  &__item {
    min-width: 0;
  }

  &__label {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
    word-break: break-all;

    &--primary {
      color: #409eff;
      font-size: 16px;
    }
  }
}

.detail-cards {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.detail-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  overflow: hidden;

  &--full {
    width: 100%;
  }

  &--last {
    margin-bottom: 0;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #fafbfc;
    border-bottom: 1px solid #f0f2f5;
  }

  &__icon {
    font-size: 16px;
    color: #409eff;

    &--goods {
      color: #409eff;
    }

    &--work {
      color: #909399;
    }

    &--money {
      color: #e6a23c;
    }

    &--supply {
      color: #67c23a;
    }

    &--edit {
      color: #f56c6c;
    }
  }

  &__title {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  &__sub {
    margin-left: auto;
    font-size: 12px;
    color: #909399;
  }

  &__actions {
    margin-left: auto;
    display: flex;
    gap: 8px;
  }

  &__body {
    padding: 16px;

    &--table {
      padding: 12px 16px 16px;
    }
  }
}

.cloth-thumb {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  cursor: pointer;
}

.work-handle-form {
  .el-form-item {
    margin-bottom: 16px;
  }
}

.work-pic-panel {
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  padding: 12px;
  background: #fafbfc;
}

.work-pic-upload {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.work-pic-tip {
  font-size: 12px;
  color: #909399;
}

.work-pic-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.work-pic-item {
  position: relative;
  width: 88px;
  height: 88px;
}

.work-pic-thumb {
  width: 88px;
  height: 88px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

.work-pic-remove {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s;
}

.work-pic-item:hover .work-pic-remove {
  opacity: 1;
}

.work-pic-empty {
  font-size: 12px;
  color: #c0c4cc;
  text-align: center;
  padding: 16px 0;
}

.work-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 1200px) {
  .work-summary {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>

<style lang="less">
.work-process-dialog {
  display: flex;
  flex-direction: column;
  max-height: 92vh;
  margin-top: 4vh !important;
  margin-bottom: 4vh;
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header {
    flex-shrink: 0;
    padding: 16px 24px 12px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-dialog__body {
    flex: 1;
    min-height: 0;
    padding: 16px 20px !important;
    overflow-x: hidden;
    overflow-y: auto;
    background: #f5f7fa;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #dcdfe6;
      border-radius: 3px;
    }
  }

  .el-dialog__footer {
    flex-shrink: 0;
    padding: 12px 24px 16px;
    border-top: 1px solid #ebeef5;
    background: #fff;
  }
}
</style>
